import axios from "axios";


export const PartialMatchVerification = async (params: {
  ciam_token: string;
  fname: string;
  lname: string;
}): Promise<void> => {
  const { ciam_token, fname, lname } = params;
  const { data } = await axios.get(
    `api/v2/check_patient_attempts`,{
        params: {
            ciam_token : ciam_token,
            fname: fname,
            lname: lname
        }
});

  return data;
};